import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error("Error no controlado en la interfaz:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-6">
          <div className="max-w-md text-center space-y-4">
            <p className="text-lg font-medium">Algo ha ido mal</p>
            <p className="text-sm text-muted-foreground">
              Se ha producido un error inesperado en la pantalla. Recarga la página para continuar.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="rounded-xl px-4 py-2 bg-primary text-primary-foreground font-medium"
            >
              Recargar página
            </button>
            <details className="text-left text-xs text-muted-foreground/70 bg-muted/30 rounded-xl p-3 mt-2 whitespace-pre-wrap break-words">
              <summary className="cursor-pointer">Detalle técnico (envíalo a soporte)</summary>
              {String(this.state.error?.message || this.state.error)}
              {this.state.info?.componentStack ? `\n${this.state.info.componentStack}` : ""}
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
